import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import { ArcRoutes } from '../../../pages/arc/constants/routes';
import { Employee } from '../../../pages/arc/features/employment/employment-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { useBasePath } from '../../hooks/useBasePath';
import { useSystemState } from '../../hooks/useSystemState';

export const withEmployeeSelect = () => (WrappedComponent: React.ComponentType<any>) => {
	return (props: React.PropsWithChildren<any>) => {
		const location = useLocation();
		const employeeSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${ArcRoutes.EmployeeSearch}`);
		const currentEmployee = useSelector<TcsmStates, Employee>(state => state.employmentState?.currentEmployee);
		const currentCycleState = useSystemState();

		if (!currentEmployee && currentCycleState) {
			return (
				<Redirect to=
					{
						{
						pathname: employeeSelect,
							state: {
								actionLink: location.pathname,
							},
						}
					}
				/>);
		}
		return (<WrappedComponent {...props}>
			{props.children}
		</WrappedComponent>);

	};
};
